/// log出力用
export class Logger {
  static error(...args) {
    /// eslint-disable-next-line no-console
    console.error(...args);
  }
}
